import { useTranslation } from "next-i18next";
import Icon from "@ui-kit/icons/Icon.web";
import { Badge, ChildBadgeProps } from "@ui-kit/data-display/Badge/Badge";

export const SecureBadge = ({ isVisible = true }: ChildBadgeProps) => {
  const { t } = useTranslation("purchases");
  const icon = (
    <Icon.Shield
      boxSize={{ base: "element.md", sm: "element.xl" }}
      mr="sm"
      aria-label={t("secure icon")}
    />
  );

  return (
    <Badge
      icon={icon}
      text={t("100% Secure")}
      isVisible={isVisible}
      data-testid="secure-badge"
    />
  );
};
